import { Box, Flex, Text } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import { SCREEN_SM } from 'utils/constants';

const ActivityHeader = () => {
  const isScreenSmall = useMediaQuery({ query: `(max-width: ${SCREEN_SM})` });

  return (
    <Flex
      width="full"
      alignItems="center"
      h={10}
      px={4}
      mt={isScreenSmall ? 2 : 6}
      bg="primary"
      borderTopRadius={isScreenSmall ? 0 : 8}
      gap={3}
    >
      {/* Icon spacer */}
      {!isScreenSmall && <Box w={10} />}

      <Box flex={2}>
        <Text size="xs">Event</Text>
      </Box>
      <Box flex={1} textAlign="right">
        <Text size="xs">Amount</Text>
      </Box>
      {!isScreenSmall && (
        <Box flex={1} textAlign="right">
          <Text size="xs">Date</Text>
        </Box>
      )}
      {/* Expand arrow spacer */}
      <Box w={4} />
    </Flex>
  );
};

export default ActivityHeader;
